import { Box, Input, ListItemText, MenuItem, Select, SelectChangeEvent } from '@mui/material'

import React, { useEffect } from 'react'

import { loginDirectToChainThunk } from '@react/chainThunks/loginToChainThunk'
import { useOtChainState, useOtDispatch } from '@react/redux/store'
import { UserConnection } from '@shared/DeploymentConfigTypes'
import { EthAddr } from '@shared/SchemaTypes'

/* eslint no-restricted-globals:0*/

export function DirectConnectionMenu(): React.ReactElement {
  const USER_STORAGE_KEY = 'directUserAddr'
  const {
    userConnection,
    isLoggedIn,
    chainConfiguration: { perimeterAddresses },
    stageConfiguration: { userConnections },
  } = useOtChainState()

  // const chainConfigurations = stageConfiguration.chainConfigurations || []
  // const isLocalhost = location.hostname === 'localhost'

  const dispatch = useOtDispatch()
  const [selectedUserAddr, setSelectedUserAddr] = React.useState<EthAddr>(
    userConnection?.accountAddr ?? localStorage.getItem(USER_STORAGE_KEY) ?? userConnections[0].accountAddr ?? ''
  )

  useEffect(() => {
    if (userConnections && perimeterAddresses && !isLoggedIn) {
      const accountAddr = localStorage.getItem(USER_STORAGE_KEY) ?? userConnections[0].accountAddr
      if (accountAddr) {
        setSelectedUserAddr(accountAddr)

        const userConnection: UserConnection | undefined = userConnections.find(
          (uc: UserConnection) => uc.accountAddr === accountAddr
        )

        dispatch(loginDirectToChainThunk(userConnection as UserConnection))
      }
    }
  }, [userConnections, perimeterAddresses, isLoggedIn])

  return (
    <Box>
      <Select
        style={{ width: 250 }}
        labelId="network-label"
        id="network-select"
        input={<Input id="network-select" />}
        value={selectedUserAddr}
        renderValue={(selectedUserAddr: string) => {
          const userConnection: UserConnection | undefined = userConnections.find(
            (uc: UserConnection) => uc.accountAddr === selectedUserAddr
          )
          const accountAddr = userConnection?.accountAddr || ''
          const name = userConnection?.companyProfile?.companyName || userConnection?.roleEnum || accountAddr

          return (
            <MenuItem
              value={accountAddr}
              key={accountAddr}
              style={{
                paddingLeft: 12,
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'center',
              }}
            >
              {userConnection && <ListItemText primary={name} />}
            </MenuItem>
          )
        }}
        onChange={(event: SelectChangeEvent) => {
          const accountAddr = event.target.value as string

          localStorage.setItem(USER_STORAGE_KEY, accountAddr)
          setSelectedUserAddr(accountAddr)

          const userConnection: UserConnection | undefined = userConnections.find(
            (uc: UserConnection) => uc.accountAddr === accountAddr
          )

          dispatch(loginDirectToChainThunk(userConnection as UserConnection))
        }}
      >
        {userConnections.map((userConnection: UserConnection) => {
          return (
            <MenuItem
              value={userConnection.accountAddr}
              key={`${userConnection.accountAddr}`}
              style={{
                paddingLeft: 12,
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'center',
              }}
            >
              <ListItemText
                primary={
                  userConnection?.companyProfile?.companyName ||
                  userConnection?.roleEnum ||
                  userConnection?.accountAddr ||
                  ''
                }
              />
            </MenuItem>
          )
        })}
      </Select>
    </Box>
  )
}
